export enum SingleSystemSettingsTab {
  Status = 'status',
  Notifications = 'notifications',
  EventLog = 'event-log',
  Menu = 'menu',
  History = 'history',
  Devices = 'devices',
  SystemDiagram = 'system-diagram',
  CustomerInfo = 'customer-info',
  AboutManufacturer = 'about-manufacturer',
  DeviceScheduling = 'device-scheduling',
  Documents = 'documents',
}

export enum SingleSystemSettingsLokalisationId {
  Status = 'label.status',
  Notifications = 'label.notifications',
  History = 'label.history',
  Menu = 'label.menu',
  MainMenu = 'label.main-menu',
  Devices = 'label.devices',
  Scheduling = 'label.scheduling',
  AboutManufacturer = 'label.system-profile.about-manufacturer',
  Documents = 'label.documents',
  EventLog = 'label.event-log',
  SystemDiagram = 'label.system-profile.system-diagram',
  CustomerInfo = 'label.customer-info',
}

export enum CLMBrandId {
  CLM = 'CLM',
  CLIMATEMASTER = 'CLIMATEMASTER',
}

export enum Brands {
  AIRSITE = 'airsite',
  AIT = 'ait',
  BIAWAR = 'biawar',
  CETETHERM = 'cetetherm',
  CLIMATEMASTER = 'climatemaster',
  CONTURA = 'contura',
  CTA = 'cta',
  CTC = 'ctc',
  DZD = 'dzd',
  DANDELION = 'dandelion',
  ENERTECH = 'enertech',
  HOIAX = 'hoiax',
  IEC = 'iec',
  JAMA = 'jama',
  JASPI = 'jaspi',
  METROTHERM = 'metrotherm',
  MHI = 'mhi',
  MYUPLINK = 'myuplink',
  NIBE = 'nibe',
  NIBEF = 'nibef',
  NOVELAN = 'novelan',
  ROTH = 'roth',
  TEMPEFF = 'tempeff',
  TIKI = 'tiki',
}

export enum MenuSystemTypes {
  None = 'none',
  Complete = 'complete',
  Simplified = 'simplified',
}
